export const DATA_OVERVIEW_ENDPOINT =
  process.env.VUE_APP_BASIC_URL + "/ws/dataoverview";

export const EMPTY_DATA_OVERVIEW_LIST = [];
